export const SidebarNavItem = {
  extends: 'Link',
  flow: 'x',
  gap: 'Z',
  align: 'center',
  padding: 'Z A',
  borderRadius: 'Z',
  cursor: 'pointer',
  textDecoration: 'none',
  transition: 'background 150ms, border 150ms',

  '@tabletS': {
    padding: 'Z',
    justifyContent: 'center',
  },

  NavIcon: {
    extends: 'Icon',
    width: 'A',
    height: 'A',
    color: 'textSoft',
  },
  NavLabel: {
    fontSize: 'A',
    fontWeight: '500',
    color: 'textSoft',
    '@tabletS': { display: 'none' },
  },
}
